<template>
  <div>
    <voiceConsultation
      v-if="step === 1"
      @complete="onVoiceComplete"
    />
    <consultationChoice
      v-if="step === 2"
      :diag-info="diagInfo"
      @confirm="onSymptomConfirm"
    />
  </div>
</template>

<script>
import ConsultationChoice from './consultationChoice.vue'
import voiceConsultation from './voiceConsultation.vue'

export default {
  components: { ConsultationChoice, voiceConsultation },
  data() {
    return {
      step: 1,
      diagInfo: null
    }
  },
  methods: {
    onVoiceComplete(payload) {
      this.diagInfo = {
        chDiagDictionaryCode: payload.chDiagDictionaryCode,
        chDiagName: payload.chDiagName, // 新增：病名传递给症状选择页
        storeCode: this.$store.state.user?.storeCode || 'CS00001',
        commonSign: payload.matchResult || 1,
        mainSign: 1
      }
      this.step = 2
    },
    onSymptomConfirm(selectedMap) {
      console.log('最终选择:', selectedMap)
    }
  }
}
</script>
